import * as Yup from 'yup';

export default Yup.object().shape({
  supplier: Yup.object().shape({
    name: Yup.string().required('Please type the name of your business.'),
  }),
});
